import React from "react";

const S = { width: 18, height: 18, viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round" as const, strokeLinejoin: "round" as const };

export function IcoUndo() {
  return (
    <svg {...S}>
      <path d="M3 7v6h6" />
      <path d="M21 17a9 9 0 00-9-9 9 9 0 00-6 2.3L3 13" />
    </svg>
  );
}

export function IcoRedo() {
  return (
    <svg {...S}>
      <path d="M21 7v6h-6" />
      <path d="M3 17a9 9 0 019-9 9 9 0 016 2.3L21 13" />
    </svg>
  );
}

export function IcoText() {
  return (
    <svg {...S}>
      <path d="M5 5h14M12 5v14M9 19h6" />
    </svg>
  );
}

export function IcoImage() {
  return (
    <svg {...S}>
      <rect x="3" y="5" width="18" height="14" rx="2" />
      <path d="M7 15l3-3 3 3 4-5" />
      <circle cx="9" cy="9" r="1.5" fill="currentColor" stroke="none" />
    </svg>
  );
}

export function IcoLine() {
  return (
    <svg {...S}>
      <path d="M4 20L20 4" />
    </svg>
  );
}

export function IcoRect() {
  return (
    <svg {...S}>
      <rect x="5" y="7" width="14" height="10" rx="1" />
    </svg>
  );
}

export function IcoCircle() {
  return (
    <svg {...S}>
      <circle cx="12" cy="12" r="7" />
    </svg>
  );
}

export function IcoBarcode() {
  return (
    <svg {...S} strokeWidth={1.8}>
      <path d="M5 7v10M7 7v10M9 9v6M11 7v10M13 8v8M15 7v10M17 9v6M19 7v10" />
    </svg>
  );
}

export function IcoQr() {
  return (
    <svg {...S} strokeWidth={1.8}>
      <rect x="4" y="4" width="7" height="7" />
      <rect x="13" y="4" width="7" height="7" />
      <rect x="4" y="13" width="7" height="7" />
      <path d="M15 13h2v2h-2zM18 13h2v2h-2zM13 16h2v2h-2zM16 16h2v2h-2zM19 16h2v2h-2zM13 19h2v2h-2zM16 19h2v2h-2z" fill="currentColor" stroke="none" />
    </svg>
  );
}

export function IcoEac() {
  return (
    <svg {...S} strokeWidth={1.6}>
      <rect x="5" y="5" width="14" height="14" rx="1" />
      <path d="M9 9h6M9 12h6M9 15h4" strokeWidth={1.5} />
    </svg>
  );
}

export function IcoCe() {
  return (
    <svg {...S} strokeWidth={1.7}>
      <path d="M8 7c0 0-1 5-1 10M8 7h4.5a2.5 2.5 0 010 5H8M8 14h4.5a2.5 2.5 0 010 5H8" />
      <path d="M15.5 7L17 17M17.5 7L19 17" />
    </svg>
  );
}

export function IcoClass({ n }: { n: 1 | 2 | 3 }) {
  return (
    <svg {...S}>
      <circle cx="12" cy="12" r="7" />
      <text x="12" y="15.5" textAnchor="middle" fontSize="9" fontWeight="600" fill="currentColor" stroke="none">
        {n}
      </text>
    </svg>
  );
}

export function IcoAlignL() {
  return (
    <svg {...S}>
      <path d="M6 6h12M6 12h8M6 18h10" />
    </svg>
  );
}
export function IcoAlignC() {
  return (
    <svg {...S}>
      <path d="M6 6h12M8 12h8M7 18h10" />
    </svg>
  );
}
export function IcoAlignR() {
  return (
    <svg {...S}>
      <path d="M6 6h12M10 12h8M5 18h10" />
    </svg>
  );
}
export function IcoAlignT() {
  return (
    <svg {...S}>
      <path d="M6 6h12M8 10v10M12 8v12" />
    </svg>
  );
}
export function IcoAlignM() {
  return (
    <svg {...S}>
      <path d="M6 12h12M8 6v4M8 14v4M16 6v4M16 14v4" />
    </svg>
  );
}
export function IcoAlignB() {
  return (
    <svg {...S}>
      <path d="M6 18h12M8 8v10M12 6v12" />
    </svg>
  );
}

export function IcoLayerUp() {
  return (
    <svg {...S}>
      <path d="M12 4l8 5H4l8-5zM4 14l8 5 8-5" />
    </svg>
  );
}
export function IcoLayerDown() {
  return (
    <svg {...S}>
      <path d="M12 20l8-5H4l8 5zM4 10l8-5 8 5" />
    </svg>
  );
}
export function IcoLayerFwd() {
  return (
    <svg {...S}>
      <path d="M8 6l4-2 4 2M8 12l4 2 4-2M8 18l4 2 4-2" />
    </svg>
  );
}
export function IcoLayerBack() {
  return (
    <svg {...S}>
      <path d="M16 6l-4-2-4 2M16 12l-4 2-4-2M16 18l-4 2-4-2" />
    </svg>
  );
}

export function IcoDistX() {
  return (
    <svg {...S}>
      <path d="M4 12h3M17 12h3M10 8v8" />
      <path d="M7 12h10" strokeDasharray="2 2" />
    </svg>
  );
}
export function IcoDistY() {
  return (
    <svg {...S}>
      <path d="M12 4v3M12 17v3M8 10h8" />
      <path d="M12 7v10" strokeDasharray="2 2" />
    </svg>
  );
}

export function IcoSpreadX() {
  return (
    <svg {...S}>
      <rect x="4" y="9" width="4" height="6" rx="0.5" />
      <rect x="10" y="9" width="4" height="6" rx="0.5" />
      <rect x="16" y="9" width="4" height="6" rx="0.5" />
    </svg>
  );
}
export function IcoSpreadY() {
  return (
    <svg {...S}>
      <rect x="9" y="4" width="6" height="4" rx="0.5" />
      <rect x="9" y="10" width="6" height="4" rx="0.5" />
      <rect x="9" y="16" width="6" height="4" rx="0.5" />
    </svg>
  );
}
